var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#41479B"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "94.316,0 0,0 0,19.977 94.316,81.77  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "0,68.299 0,94.316 39.71,94.316  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "0,161.684 0,187.701 39.71,161.684  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "256,19.977 256,0 161.684,0 161.684,81.77  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "256,187.701 256,161.684 216.29,161.684  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "161.684,174.23 161.684,256 256,256 256,236.023  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "256,94.316 256,68.299 216.29,94.316  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "0,236.023 0,256 94.316,256 94.316,174.23  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "256,236.023 256,216.059 172.232,161.684 196.98,161.684 256,199.995 256,187.701    216.29,161.684 256,161.684 256,148.21 148.211,148.21 148.211,256 161.684,256 161.684,174.23  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "0,148.21 0,161.684 39.71,161.684 0,187.701 0,206.602 69.197,161.684 93.945,161.684    0,222.666 0,236.023 94.316,174.23 94.316,256 107.789,256 107.789,148.21  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "107.789,0 94.316,0 94.316,81.77 0,19.977 0,41.839 80.842,94.316 56.094,94.316 0,57.904    0,68.299 39.71,94.316 0,94.316 0,107.79 107.789,107.79  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "256,107.79 256,94.316 216.29,94.316 256,68.299 256,49.157 186.432,94.316 161.684,94.316    256,33.093 256,19.977 161.684,81.77 161.684,0 148.211,0 148.211,107.79  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "256,148.21 256,107.79 148.211,107.79 148.211,0 107.789,0 107.789,107.79 0,107.79    0,148.21 107.789,148.21 107.789,256 148.211,256 148.211,148.21  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "69.197,161.684 0,206.602 0,222.666 93.945,161.684  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "172.232,161.684 256,216.059 256,199.995 196.98,161.684  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "80.842,94.316 0,41.839 0,57.904 56.094,94.316  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "186.432,94.316 256,49.157 256,33.093 161.684,94.316  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 305.73,
    y: 280.18,
    style: {
      fill: "#82AFFF"
    },
    width: 137.56,
    height: 106.29
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C86464"
    },
    d: "M305.726,386.478c0,36.258,40.642,65.652,68.778,65.652l0,0c25.01,0,68.778-29.394,68.778-65.652  H305.726z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M392.871,319.002c2.214,0.391,5.992,0.912,6.383,6.253s-1.563,24.359-3.517,26.704  c0,0,6.383,14.459,6.643,23.056c0.261,8.597-0.912,34.324-0.13,38.427s3.712,12.505,3.712,12.505s-8.988-5.276-12.505-1.954  s-16.413,7.816-21.493,2.54c0,0,6.057-17.195,6.057-36.734s0-67.801,0-67.801s2.54-2.019,5.862-2.084  S392.871,319.002,392.871,319.002z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFF5E1"
    },
    d: "M394.174,422.3c0.391,2.475,1.433,4.299,0.912,5.21c-0.521,0.912-3.908,9.249-1.954,9.249   c1.954,0,5.341-1.042,6.253-2.866s1.303-4.559,1.824-5.341s-0.912-4.689-2.084-5.341S394.174,422.3,394.174,422.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFF5E1"
    },
    d: "M371.639,324.473l-7.164,0.912c0,0,0.912-4.689,1.042-7.946c0.13-3.256,0.391-9.248,0.391-9.248   s5.08-3.126,5.21-3.648c0.065-0.26,0.668-1.889,0.195-2.735s-2.019-0.912-2.019-0.912s-5.992,3.126-5.992,3.647s0,3.648-0.651,4.82   s-4.299,10.942-4.559,13.547c-0.261,2.605-0.651,8.076,0.391,8.337c1.042,0.26,11.854,1.433,13.026,0.912   S371.639,324.473,371.639,324.473z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#464655"
    },
    points: "404.096,298.746 378.021,298.746 378.021,286.436 369.033,286.436 369.033,298.746   342.959,298.746 342.959,307.734 369.033,307.734 369.033,425.947 378.021,425.947 378.021,307.734 404.096,307.734 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#963C3C"
    },
    d: "M388.703,314.703c0,0,8.727,2.513,9.9-0.391c1.368-3.387-3.191-3.843-4.038-7.425  c-0.095-0.401-0.912-5.21-4.429-6.122c-3.517-0.912-6.774,0-6.904,2.345C383.102,305.455,388.703,314.703,388.703,314.703z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFF5E1"
    },
    d: "M384.014,325.775c-0.257,0.043-0.651-2.605-0.13-5.862s0-4.299,0-4.299s-3.647,0.391-3.647-1.042  c0-1.433,0.782-8.076,2.996-11.463c0,0,1.563,1.954,4.429,1.954c0,0-0.13,2.345,1.433,3.908c0,0-1.954,1.693-1.042,2.866  s2.605,2.605,2.605,2.605s0.13,2.736,2.214,4.559C392.871,319.002,390.266,324.733,384.014,325.775z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 348.32,
    y: 382.31,
    style: {
      fill: "#464655"
    },
    width: 0.782,
    height: 15.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.47,
    y: 379.31,
    style: {
      fill: "#464655"
    },
    width: 0.782,
    height: 21.502
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354.61,
    y: 376.57,
    style: {
      fill: "#464655"
    },
    width: 0.782,
    height: 26.986
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.76,
    y: 372.65,
    style: {
      fill: "#464655"
    },
    width: 0.782,
    height: 34.823
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.9,
    y: 367.52,
    style: {
      fill: "#464655"
    },
    width: 0.782,
    height: 45.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.05,
    y: 367.52,
    style: {
      fill: "#464655"
    },
    width: 0.782,
    height: 47.18
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M378.152,392.209c-3.454-17.963-13.026-28.397-16.413-28.918s-5.862,2.215-6.122,4.169  s-2.084,7.816-5.862,10.551c-3.778,2.736-10.812,4.299-12.375,9.379s2.605,7.295,5.08,6.773c0.185-0.039,0.368-0.111,0.552-0.173  l26.629,32.756c0.967,1.19,2.85,0.995,3.524-0.383C375.903,420.769,381.097,407.525,378.152,392.209z M345.247,392.572  c1.044-1.12,1.485-2.667,0.339-4.271c-1.954-2.736-4.168,1.172-4.168,1.172s-0.651-3.387,4.429-5.08s10.812-4.559,13.417-10.681  s2.475-4.95,2.475-4.95s10.421,5.862,11.854,24.229s-3.647,25.792-3.647,25.792L345.247,392.572z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFF5E1"
    },
    d: "M369.033,352.91c-1.196,0.766-2.274,1.424-3.029,1.817c-2.442,1.27-5.373,2.54-5.666,3.712   s-1.954,2.149-1.856,3.517c0.098,1.368,0,5.471,0,5.471c1.465-0.293,4.396-0.782,5.373-2.54c0.977-1.759,1.856-5.178,4.983-6.643   c0.056-0.026,0.137-0.053,0.195-0.079L369.033,352.91L369.033,352.91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFF5E1"
    },
    d: "M394.923,327.957c-1.465,0.684-5.862,5.96-6.546,8.402s-2.833,8.206-2.833,8.206   s-4.439,0.58-7.523,2.305v8.532c1.708-0.495,3.22-0.982,4.103-1.458c2.54-1.368,6.155-3.908,8.011-4.396s3.419-3.615,4.103-5.471   s2.833-7.327,3.126-11.04S396.388,327.273,394.923,327.957z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M374.504,454.346l-0.342-0.055c-69.822-11.024-70.625-71.499-70.625-74.066v-102.23h141.935v102.23  c0,2.568-0.803,63.042-70.625,74.066L374.504,454.346z M307.915,282.373v97.852c0,2.412,0.756,59.1,66.589,69.688  c65.834-10.588,66.589-67.276,66.589-69.688v-97.852H307.915z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMs);
export default __webpack_public_path__ + "static/media/MS.acd9a4bce9c6b986afcc62bdb765da64.svg";
export { ForwardRef as ReactComponent };